import { render, staticRenderFns } from "./SdsSection15Form.vue?vue&type=template&id=dba8c9cc"
import script from "./SdsSection15Form.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection15Form.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports